import { take } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { CarpetaService } from 'app/services/carpeta.service';
import { EstadoPagare } from 'app/models/pagare.model';
import { Parametro } from 'app/models/parametro.model';
import { FileUploadComponent } from 'app/components/file-upload/file-upload.component';
import { Adjunto, DetalleCarpeta } from 'app/models/carpeta.model';
import { saveAs } from 'file-saver';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
import { AuditService } from 'app/services/audit.service';
@Component({
    selector: 'detalle',
    templateUrl: './detalle.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DetalleComponent {
    constructor(
        private route: Router,
        private actvatedRoute: ActivatedRoute,
        private _carpeta: CarpetaService,
        private _audit: AuditService
    ) {}
    @ViewChild('fileUpload') fileUpload: FileUploadComponent;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlert: boolean = false;
    montoRecaudadomaxValue: number = null;
    showModalDetail: boolean = false;
    // auditComentario: string = null;

    infoPagare = {
        ID_ESTADO: null,
        COMENTARIO: null,
        NRO_ROL: null,
        MONTO_RECAUDADO: null,
        MOTIVO_ANULACION: null,
    };
    public customPatterns = { '0': { pattern: new RegExp('^[0-9]{1,20}$') } };
    carpeta: DetalleCarpeta = {
        CUENTA_FINANCIERA: null,
        FOLIO: null,
        RAZON_SOCIAL: null,
        RUT: null,
        MONTO_TOTAL: null,
        ADJUNTO_TOTAL: null,
        ADJUNTO_PAGARE: null,
        ADJUNTO_NOTARIADO: null,
        ADJUNTO_FACTURA: null,
        ADJUNTO_CONTRATO: null,
        ADJUNTO_OTRO: null,
        RUTDV: null,
    };

    respuestaDocumentos: Adjunto[] = [];
    estadosPagare: EstadoPagare[] = [];
    motivosAnulacion: Parametro[] = [];
    estadoSelected: number = 0;
    Comentario: string = '';
    Rol: number = null;
    montoRecaudado: number = 0;
    montoGuardado: number = 0;
    isDisabled: boolean = true;
    rolDisabled: boolean = true;
    respuestaAdjuntos: Parametro[] = [];
    tipoSelected: string = '';
    motivoSelected: string = '';
    fileUploadAceptedTypes: string = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/png,image/jpeg';
    fileUploadPlaceholder: string =
        '<p class="filepond--text-action">Arrastre el archivo a esta área o </p><p class="filepond--label-action"> haz click aquí </p><p class="filepond--text-action-secondary">Máximo 5 MB - Formato PDF, JPG, PNG, DOCX</p>';

    file: {
        file: File | string;
        fileext: string;
        filename: string;
        filetype: string;
        status: boolean;
    } = {
        file: null,
        fileext: null,
        filename: null,
        filetype: null,
        status: false,
    };

    fileUploading: boolean = false;
    ID_CARPETA: number;
    ID_FOLIO: string = null;
    guardoCambio: boolean = false;
    ngOnInit() {
        this.ID_CARPETA = this.actvatedRoute.snapshot.params.ID_CARPETA;
        this._carpeta
            .obtenerCarpeta(this.ID_CARPETA)
            .pipe(take(1))
            .subscribe({
                next: (resp) => {
                    this.carpeta = resp;
                    this.montoRecaudadomaxValue = this.carpeta.MONTO_TOTAL;

                    this._carpeta
                        .obtenerPagare(this.carpeta.FOLIO)
                        .pipe(take(1))
                        .subscribe({
                            next: (data) => {
                                this.infoPagare = data;
                            },
                            error: (err: any) => {
                                console.log(err);
                            },
                            complete: () => {
                                console.log(this.infoPagare.ID_ESTADO);
                                this.estadoSelected = this.infoPagare.ID_ESTADO;
                                this.Comentario = this.infoPagare.COMENTARIO;
                                this.Rol = this.infoPagare.NRO_ROL;
                                this.montoRecaudado = this.infoPagare.MONTO_RECAUDADO;
                                // this.ID_FOLIO = this.carpeta.FOLIO;
                                this.listarAudit(this.carpeta.FOLIO);

                                //CON ACUERDO
                                if (this.infoPagare.ID_ESTADO == 8) {
                                    this.isDisabled = false;
                                    this.montoGuardado = this.infoPagare.MONTO_RECAUDADO;
                                    console.log('hola');
                                }
                                //ANULADO
                                if (this.infoPagare.ID_ESTADO == 9) {
                                    this.motivoSelected = this.infoPagare.MOTIVO_ANULACION;
                                }
                                //NUMERO ROL
                                if (this.infoPagare.ID_ESTADO == 7) {
                                    console.log('hola');
                                }
                            },
                        });
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });

        this.obtenerDocumentosCarpeta();

        this._carpeta
            .listarEstadosPagare()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.estadosPagare = data;
                },
                error: (err: any) => {},
                complete: () => {
                    let optDefault: EstadoPagare = {
                        ID_ESTADO: 0,
                        NOMBRE_ESTADO: '',
                    };
                    this.estadosPagare.unshift(optDefault);
                    this.estadoSelected = this.estadosPagare[0].ID_ESTADO;
                },
            });
        this._carpeta
            .listarTipoAdjuntos()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.respuestaAdjuntos = data;
                },
                error: (err: any) => {},
                complete: () => {
                    let optDefault: Parametro = {
                        ID: null,
                        TIPO: null,
                        NOMBRE: null,
                        VALOR: '',
                        ACTIVO: null,
                    };
                    this.respuestaAdjuntos.unshift(optDefault);
                    this.tipoSelected = this.respuestaAdjuntos[0].VALOR;
                },
            });

        this._carpeta
            .listarTipoMotivosAnulacion()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.motivosAnulacion = data;
                },
                error: (err: any) => {},
                complete: () => {
                    let optDefault: Parametro = {
                        ID: null,
                        TIPO: null,
                        NOMBRE: null,
                        VALOR: '',
                        ACTIVO: null,
                    };
                    this.motivosAnulacion.unshift(optDefault);
                    this.motivoSelected = this.motivosAnulacion[0].VALOR;
                },
            });
        // console.log('FOLIO:.. ');
    }

    columns: TableColumn[] = [
        {
            columnDef: 'FECHA',
            header: 'fecha',
            headerClass: 'text-left pr-1.5',
            columnClass: 'pl-6 px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/YYYY HH:mm:ss',
            columnSort: true,
        },
        {
            columnDef: 'USUARIO',
            header: 'usuario',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'FOLIO_ESTADO',
            header: 'Estado',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'flex items-center gap-2',
            columnType: 'custom',
            columnFormat: '',
            columnSort: true,
            columFunction: this.printEstado,
        },
        {
            columnDef: 'COMENTARIO',
            header: 'comentario',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left truncate',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
    ];

    displayedColumns: string[] = ['fecha', 'usuario', 'estadoTabla', 'comentario'];

    dataSourceAudit = null;
    selection = new SelectionModel<any>(true, []);

    // onTableAction(row: any) {
    //     //console.log('ver detalles de', row);
    //     this.auditComentario = row.COMENTARIO;
    //     this.showModalDetail = true;
    // }
    // closeModalDetalle() {
    //     this.showModalDetail = false;
    //     this.auditComentario = null;
    // }

    printEstado(row: any, attribute: string): string {
        let dict = {
            1: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            PRE-EMITIDO
                        </p>
                    </div>
                </div>`,
            2: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-01">
                        <p class="paragraph-tag_upper text-primary">
                            CANCELADO
                        </p>
                    </div>
                </div>`,
            3: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            EMITIDO
                        </p>
                    </div>
                </div>`,
            4: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            ENVIADO A NOTARÍA
                        </p>
                    </div>
                </div>`,
            5: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            NOTARIADO
                        </p>
                    </div>
                </div>`,
            6: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            ENVIADO A JUDICIAL
                        </p>
                    </div>
                </div>`,
            7: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            JUDICIALIZADO
                        </p>
                    </div>
                </div>`,
            8: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            CON ACUERDO
                        </p>
                    </div>
                </div>`,
            9: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-01">
                        <p class="paragraph-tag_upper text-primary">
                            ANULADO
                        </p>
                    </div>
                </div>`,
            10: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            DEVUELTO A CLIENTE
                        </p>
                    </div>
                </div>`,
        };
        return dict[row[attribute]] || '';
    }

    printEstadoMobile(attribute: string): string {
        let dict = {
            1: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            PRE-EMITIDO
                        </p>
                    </div>
                </div>`,
            2: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-01">
                        <p class="paragraph-tag_upper text-primary">
                            CANCELADO
                        </p>
                    </div>
                </div>`,
            3: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            EMITIDO
                        </p>
                    </div>
                </div>`,
            4: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            ENVIADO A NOTARÍA
                        </p>
                    </div>
                </div>`,
            5: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            NOTARIADO
                        </p>
                    </div>
                </div>`,
            6: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            ENVIADO A JUDICIAL
                        </p>
                    </div>
                </div>`,
            7: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            JUDICIALIZADO
                        </p>
                    </div>
                </div>`,
            8: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            CON ACUERDO
                        </p>
                    </div>
                </div>`,
            9: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-01">
                        <p class="paragraph-tag_upper text-primary">
                            ANULADO
                        </p>
                    </div>
                </div>`,
            10: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            DEVUELTO A CLIENTE
                        </p>
                    </div>
                </div>`,
        };
        return dict[attribute] || '';
    }

    setFileInfo($event: any) {
        //console.log($event);
        this.file = $event;
    }

    subirArchivo() {
        if (this.tipoSelected == '' || !this.file.status || this.fileUploading) {
            return;
        }
        this.fileUploading = true;
        // console.log(this.fileCsv);
        this._carpeta
            .subirAdjunto(this.ID_CARPETA, this.tipoSelected, this.file.file)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    //console.log('ok');
                    this.fileUploading = false;
                    this.tipoSelected = '';
                    this.fileUpload.resetFilePondFiles();
                    this.obtenerDocumentosCarpeta();
                    // this.respuestaAdjuntos = data;
                    this.alert = {
                        type: 'success',
                        message: 'Archivo subido exitosamente',
                    };
                    this.alertShow();
                },
                error: (err: any) => {
                    console.log(err);
                    console.log('notok');
                    switch (err.status) {
                        default:
                            this.alert = {
                                type: 'error',
                                message: 'No se pudo completar la operación',
                            };
                            break;
                    }

                    this.alertShow();
                    this.fileUploading = false;
                },
                complete: () => {},
            });
    }

    desactivar(value) {
        //CON ACUERDO
        if (value == 8) {
            this.isDisabled = false;
            this.rolDisabled = true;
            this.montoRecaudado = this.montoGuardado;
        } else if (value == 7) {
            this.rolDisabled = false;
            this.isDisabled = true;
        } else {
            this.rolDisabled = true;
            this.isDisabled = true;
            // this.montoRecaudado = 0;
        }
    }

    guardarCambio() {
        this.guardoCambio = true;
        this._carpeta
            .actualizaPagare(
                this.ID_CARPETA,
                this.carpeta.FOLIO,
                this.estadoSelected,
                this.motivoSelected,
                this.Comentario,
                this.Rol,
                this.montoRecaudado
            )
            .pipe(take(1))
            .subscribe({
                next: (data: any) => {
                    this.guardoCambio = false;
                    //console.log('ok');
                    this.alert = {
                        type: 'success',
                        message: 'Cambios guardados',
                    };
                    this.alertShow();

                    if (data) {
                        if (data.infoMailing) {
                            // ENVIO EMAIL NOTIFICACION CLIENTE POR SER ESTADO NOTARIADO
                            switch (data.infoMailing.notifCliente) {
                                case true:
                                    this.alert = {
                                        type: 'success',
                                        message: 'Email enviado a cliente exitosamente',
                                    };
                                    this.alertShow();
                                    break;
                                case false:
                                    this.alert = {
                                        type: 'error',
                                        message: 'No se pudo enviar email a cliente',
                                    };
                                    this.alertShow();
                                    break;
                            }

                            switch (data.infoMailing.notifAreaJudicial) {
                                case true:
                                    this.alert = {
                                        type: 'success',
                                        message: 'Email enviado a área judicial exitosamente',
                                    };
                                    this.alertShow();
                                    break;
                                case false:
                                    this.alert = {
                                        type: 'error',
                                        message: 'No se pudo enviar email a área judicial',
                                    };
                                    this.alertShow();
                                    break;
                            }
                        }
                    }
                },
                error: (err: any) => {
                    console.log(err);
                    //console.log('notok');
                    switch (err.status) {
                        default:
                            this.alert = {
                                type: 'error',
                                message: 'No se pudo completar la operación',
                            };
                            break;
                    }
                    this.alertShow();
                    this.guardoCambio = false;
                },
                complete: () => {
                    this.listarAudit(this.carpeta.FOLIO);
                },
            });
    }

    obtenerDocumentosCarpeta() {
        this._carpeta
            .obtenerDocumentosCarpeta(this.ID_CARPETA)
            .pipe(take(1))
            .subscribe({
                next: (resp) => {
                    this.respuestaDocumentos = resp;
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }

    descargarDocumento(documento: Adjunto) {
        this._carpeta.obtenerDocumento(documento.ID_ADJUNTO).subscribe({
            next: (resp) => {
                saveAs(resp.body, documento.NOMBRE_ADJUNTO.split('/')[1]);
            },
            error: (err) => {
                console.log(err);
            },
            complete: () => {},
        });
    }

    goback(): void {
        this.route.navigateByUrl('home/judicial');
    }

    alertShow() {
        this.showAlert = true;
        setTimeout(() => {
            this.showAlert = false;
        }, 3000);
    }

    listarAudit(folio) {
        this._audit
            .listarAuditCarpeta(folio)
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.dataSourceAudit = data;
                },
                error: (err: any) => {
                    //console.log(err);
                    //this.dataSourceAudit = [];
                },
                complete: () => {},
            });
    }
}
